import { Any } from '../types/Any'
import { KindKey, CustomType, TypeKey, UnionType, UnionCase } from '../symbols'
import { Type } from './type'
import { Union } from './union-type'
import { every } from '../dispatchers'

export const is = (val, T) => {
  if (T == null) return false

  if (T === Any) {
    return true
  }

  if (Array.isArray(T)) return every(val, (x) => is(x, T[0]))

  if (T === String && typeof val === 'string') return true

  if (T === Number && typeof val === 'number') return true

  if (T === Boolean && typeof val === 'boolean') return true

  if (T === Array && Array.isArray(val)) return true

  if (T[KindKey] === CustomType && T[TypeKey] === val[TypeKey]) return true

  if (T[KindKey] === UnionType) {
    if (T[UnionCase]) return T[UnionCase] === val[UnionCase]
    else return T[TypeKey] === val[TypeKey]
  }

  if (T === Type) {
    if (val[KindKey] === CustomType) return true
    else return false
  }

  if (T === Union) {
    if (val[KindKey] === UnionType) return true
    else return false
  }

  if (T === val) return true

  if (T.constructor === Object) {
    return every(Object.keys(T), (key) => is(val[key], T[key]))
  }

  return typeof T === 'function' && val instanceof T
}
